import loginImage from "../Images/side img.svg";
import { TextField } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { useState } from "react";
import axios from "axios";
import BaseUrl from "../BaseUrl";
import { useHistory } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
export default function ForgotPassword() {
  const history = useHistory();
  const [showToast, setShowToast] = useState(false);
  const [spinner, setSpinner] = useState(false);
  const [emailStatus, setEmailStatus] = useState({
    clicked: false,
    error: false,
  });
  const [apiStatus, setApiStatus] = useState({
    status: true,
  });
  const [emailValid, setEmailValid] = useState(false);
  const [email, setEmail] = useState("");
  const [userDetails, setUserDetails] = useState("");




  function isValidEmail(email) {
    // Regular expression pattern for a basic email validation
    var emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

    // Test the email against the pattern
    return emailPattern.test(email);
  }
  
  function verifyEmail() {
    setSpinner(true);
    axios
      .put(
        `${BaseUrl.baseurl}/email-marketing/user/change-password-step1?email=${email}`,
      )
      .then((res) => {
        setSpinner(false);

        setApiStatus(res.data);
        if (res.data.status) {
          setShowToast(true)
            toast.success(res.data.message,{autoClose: true,position:"top-right",duration: 3000});
          setUserDetails(res.data);
        }
        else
        {
          setShowToast(true)
            toast.error(res.data.message,{autoClose: true,position:"top-right",duration: 3000});
        }
      })
      .catch((err) => console.log("Error"));
  }

 


  

  return (
    <div className="login-parent-container md:grid md:grid-cols-2 md:gap-4">
      <div className="hidden md:block">
        <img
          src={loginImage}
          alt=""
          style={{ width: "50vw", height: "100vh", objectFit: "cover" }}
        />
      </div>
      <div className="loginLayout">
      <div style={{padding:"12px",display:"flex",flexDirection:"column",gap:"14px"}}>
            <div className="loginTypo">Forgot password</div>
            {!apiStatus.status && (
              <p className="emailpasswrong">{apiStatus.message}!</p>
            )}
            {/* {emailStatus.error && passwordStatus.error && (
            <div className="bothRequiredLayout">
              Email address and password is required!
            </div>
          )} */}
            <div style={{display:"flex",flexDirection:"column",gap:"14px"}}>
            <p className="loginEmail">Email address</p>
            <TextField
            autoComplete="off"
              type="email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                if (isValidEmail(e.target.value)) {
                  setEmailValid(true);
                } else {
                  setEmailValid(false);
                }
              }}
              onClick={() => {
                setEmailStatus({
                  clicked: true,
                  error: false,
                });
             
              }}
              // value={searchedVal}
              variant="standard"
              placeholder="Enter your email address"
              InputProps={{
                disableUnderline: true,
                endAdornment: (
                  <div style={{ height: "20px"}}></div>
                ),

                sx: {
                  padding: "10px 16px",
                  gap: "10px",
                  fontSize: "15px",
                  width: "100%",
                  alignItems: "center",
                  alignSelf: "stretch",
                  borderRadius: "4px",
                  border:'1px solid #1C485F',
                  fontWeight: 400,
                  border: emailStatus.clicked
                    ? "1px solid var(--color-secondary, #3471B8)"
                    : emailStatus.error ?
                      "1px solid var(--color-error, #FF3434)":"1px solid #1C485F",
                  background: "var(--background-color, #FAFAFA)",
                  "& input": {
                    color: "var(--color-dark-500, #868686)",
                    fontFamily: "Source Sans 3",
                    fontSize: "14px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "20px",
                  },
                },
              }}
            />
            </div>
            {!emailValid ? (
              <div className="verifyBtnBlurr">Verify</div>
            ) : (
              <div
                onClick={() => {
                  verifyEmail();
                }}
                className="loginBtn"
              >
                {spinner ? (
                  <CircularProgress
                    style={{
                      color: "var(--color-white, #FFF)",
                      height: "20px",
                      width: "20px",
                    }}
                  />
                ) : (
                  "Verify"
                )}
              </div>
            )}

            <div className="dontHaveLayout">
              <div className="dontText">If you remember your password?</div>
              <div
                className="signUpText"
                onClick={() => {
                  history.push("/Login");
                }}
              >
                Back to login
              </div>
            </div>
          </div>
          
      </div>
      {showToast && <ToastContainer />}
    </div>
  );
}
